import {Notification} from 'element-ui';

const msg = {}

msg.success = (msg) => {
    Notification({
        type: 'success',
        title: '成功',
        message: msg || ''
    })
}

msg.error = (msg) => {
    Notification({
        type: 'error',
        title: '失败',
        message: msg || ''
    })
}


msg.warning = (msg) => {
    Notification({
        type: 'warning',
        title: '警告',
        message: msg || ''
    })
}

export default msg
